import { Component } from 'react'
import { isString } from '../../framework/utils'
import { getDatadogRum } from '../../framework/externals'
import './ErrorBoundary.scss'
import type { ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  context?: string
  dataTestId?: string
}

interface State {
  hasError: boolean
}

export class NavErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  static getDerivedStateFromError(_: Error) {
    // Update error state
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    getDatadogRum()?.addError(error, {
      type: 'client_error',
      error_boundry_context: this.props.context,
      error_boundry_test_id: this.props.dataTestId,
    })
    const context = this.props.context || this.props.dataTestId
    // log the error
    const contextMsg = context ? `React error boundry for nav "${context}":` : ''
    console.log(contextMsg, error, info)
  }

  render() {
    if (this.state.hasError) {
      return null
    }
    return this.props.children
  }
}

export const wrapNavErrorBoundry = (children: ReactNode, context: string): ReactNode => {
  if (!children || isString(children)) {
    return children
  }
  return <NavErrorBoundary context={context}>{children}</NavErrorBoundary>
}

export default NavErrorBoundary
